// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCash = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12 15a3 3 0 100-6 3 3 0 000 6" />,
    <path fillRule="evenodd" d="M2 5v14h20V5zm18 10V9h-2V7H6v2H4v6h2v2h12v-2z" />
  );
export default SvgIconCash;
